import React, {useEffect, useRef, createContext} from "react";
import Hero from "./components/Hero";
import Nav from "./components/Nav";
import MobileNav from "./components/MobileNav";
import About from "./components/About";
import Services from "./components/Services";
import Work from "./components/Work";
import Contact from "./components/Contact";
import LocomotiveScroll from "locomotive-scroll";

//  Create context to share scroll instance
export const ScrollContext = createContext(null);

function App() {
  const scrollRef = useRef(null);
  const scrollInstance = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined" || !scrollRef.current) return;

    import("locomotive-scroll").then((LocomotiveScroll) => {
      scrollInstance.current = new LocomotiveScroll.default({
        el: scrollRef.current,
        smooth: true,
        lerp: 0.1,
        smartphone: { smooth: false },
        tablet: { smooth: false },
      });

      window.addEventListener("load", () => {
        setTimeout(() => scrollInstance.current?.update(), 500);
      });

      return () => scrollInstance.current?.destroy();
    });
  }, []);
  
  return (
    <ScrollContext.Provider value={scrollInstance}>
      <Nav />
      <MobileNav />
      <div data-scroll-container ref={scrollRef}>
        <Hero />
        <About />
        <Services />
        <Work />
        <Contact />
      </div>
    </ScrollContext.Provider>
  );
}

export default App;
